<template>
  <CContainer class="d-flex align-items-center min-vh">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">403</h1>
            <h4 class="pt-3">Permission Denied</h4>
            <p class="text-muted">
              The page you are looking for cannot be accessed.
            </p>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: "Page403",
};
</script>
